<template>
  <div class="casino-launcher-overlay">
    <div class="casino-launcher-overlay-wrapper">
      <circle-loader v-if="!iFrameLoaded"></circle-loader>
      <iFrame
        :src="`${sortUrl(casino.ORIGIN)}/${this.casinoLicenseId}/${this.gameData.id}?lang=en&cur=${this.gameData.userCurrencyCode}&mode=${casino.MODE}&user=${this.gameData.username}&uid=${this.gameData.userId}&token=${this.gameData.token}&lobbyURL=${returnToCasinoPage}`"
        class="casinoGameIframe"
        id="casinoIframe"
        ref="casinoGameReference"
        :width="calculatedWith"
        :height="calculatedHeight"
        allowfullscreen
        @load="iframeLoaded"
        style="border:none"
      >
      </iFrame>
    </div>
    </div>
</template>

<script>

import config from '@/config'
import Casino from '@/components/mixins/Casino'
import Screen from '@/components/mixins/Screen'
import Session from '@/components/mixins/Session'
import store from '@/store'
import { localeProperties } from '@/library/locale/i18n'
import CircleLoader from '@/components/common/CircleLoader'

export default {
  name: 'casinoLauncher',
  components: {
    CircleLoader
  },
  props: ['gameData'],
  mixins: [
    Casino,
    Screen,
    Session
  ],
  data () {
    return {
      iframeSrc: false,
      calculatedWith: '100%',
      calculatedHeight: '100%',
      trackClicksInsideIframe: false,
      iFrameLoaded: false
    }
  },
  computed: {
    casino () {
      return config.app.autoconf.CASINO
    },
    casinoLicenseId () {
      return store.getters['gap/getCasinoLicenseId']
    },
    currentLocale () {
      return localeProperties.getCurrentLocale
    },
    returnToCasinoPage () {
      return window.location.href
    }
  },
  methods: {
    iframeLoaded () {
      setTimeout(() => {
        this.iFrameLoaded = true
        this.analytics(true)
      }, 2000)
    },
    postMessageEventListener () {
      window.addEventListener('message', this.postMessageFunction, false)
    },
    postMessageFunction (event) {
      console.log('CASINO POST MESSAGE: ', event.data)
      this.iFrameLoaded = true
      this.userIsActiveInCasinoActiveGame()
    },
    analytics (iframeLoaded = false) {
      let eventName = iframeLoaded ? 'casino_game_launched' : 'casino_game_closed'
      let event = {
        'event': eventName,
        'gaEventAction': eventName,
        'gaGameId': this.gameData.id || 'N/A',
        'accountId': localStorage.customer || 'N/A'
      }
      let xtremeObj = {
        'param1': 'event',
        'param2': eventName,
        'param3': {
          'gameId': this.gameData.id,
          'accountId': localStorage.customer || 'N/A'
        }
      }
      this.updateAnalytics(event, xtremeObj)
    }
  },
  mounted () {
    this.userIsActive()
    let gameUrl = this.sortUrl(this.casino.ORIGIN) + '/' + this.casinoLicenseId + '/' + this.gameData.id + '?lang=en&cur=' + this.gameData.userCurrencyCode + '&mode=' + this.casino.MODE + '&user=' + this.gameData.username + '&uid=' + this.gameData.userId + '&token=' + this.gameData.token + '&lobbyURL=' + this.returnToCasinoPage
    console.log('CASINO staging game URL', gameUrl)
  },
  beforeMount () {
    this.postMessageEventListener()
  },
  beforeDestroy () {
    this.analytics()
    window.removeEventListener('message', this.postMessageFunction, false)
    this.iframeSrc = false
    this.iFrameLoaded = false
  }
}
</script>



// WEBPACK FOOTER //
// src/components/igaming/partials/casinoLauncher.vue